import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  class: "icon",
  viewBox: "0 0 1024 1024"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M801.856 734.016 579.904 512 801.92 289.984c18.816-18.816 18.88-49.152.064-67.968-18.752-18.752-49.216-18.752-67.904 0L512 444.032 289.92 222.016c-18.688-18.752-49.088-18.752-67.904 0-18.688 18.752-18.688 49.216.128 68.032L444.096 512 222.08 733.952c-18.816 18.752-18.816 49.152-.064 67.968C231.424 811.392 243.84 816 256 816s24.576-4.608 33.92-14.016L512 579.968l222.08 222.016A48.04 48.04 0 0 0 768 816c12.288 0 24.576-4.608 33.92-14.016 18.752-18.88 18.816-49.216-.064-67.968" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }